import { useState } from 'react'
import ConsultModal from './ConsultModal'

const videoUrl =
  'https://cdn.wujiebantu.com/upload/756739757A1743732637970ECC31BB9C/1731310833821/lgoXtHy2K8B_yb5muRWOUaHcYd0P.mp4'
const videoPoster = `${videoUrl}?vframe/jpg/offset/0.001`
function Banner() {
  const [visible, setVisible] = useState(false)

  return (
    <main className="relative" style={{ height: 'calc(100vh)' }}>
      <div className="absolute w-full h-full bottom-0 left-0 flex flex-col items-center justify-center z-[10]">
        <video
          src={videoUrl}
          poster={videoPoster}
          controls={false}
          autoPlay
          loop
          muted
          className="w-full h-full object-fill"
        />
      </div>
      <div
        className="absolute w-full h-full bottom-0 left-0 flex flex-col items-center justify-center z-[1000]"
        style={{
          background:
            'linear-gradient(0deg, rgba(0, 0, 0, 0.32) 0%, rgba(0, 0, 0, 0.32) 100%)',
        }}
      >
        <div className="text-neutral-900 text-[40px] font-semibold text-center -mt-[100px]">
          AI 时代的全能影像馆
        </div>
        <div className="text-neutral-900 text-base text-center mt-4">
          填补个性化美拍市场的空白，赋能传统人像摄影行业快速升级，打造AI时代的全能影像馆
        </div>

        <div
          className="rounded-full text-sm py-2 px-[42px] font-semibold text-white hover:text-white mr-6 text-center cursor-pointer border-2 border-[#C8C9D1] mt-[64px]"
          style={{
            background: 'rgba(255, 255, 255, 0.16)',
            backdropFilter: 'blur(4px)',
          }}
          onClick={() => setVisible(true)}
        >
          立即咨询
        </div>
      </div>
      <ConsultModal visible={visible} setVisible={setVisible} />
    </main>
  )
}

export default Banner
